import { PWA_CONFIG } from '../config/pwa.config';

export const injectPWAManifest = (website = PWA_CONFIG.COMPANY_WEBSITE) => {
  try {
    const existingLink = document.querySelector('link[rel="manifest"]');
    if (existingLink) existingLink.remove();

    // Use API URL directly (manifest allows cross-origin)
    const manifestUrl = `${PWA_CONFIG.API_BASE_URL.replace(/\/$/, '')}/pwa/manifest.json?website=${website}`;
    const manifestLink = document.createElement('link');
    manifestLink.rel = 'manifest';
    manifestLink.href = manifestUrl;
    manifestLink.crossOrigin = 'use-credentials';
    document.head.appendChild(manifestLink);
    return true;
  } catch (error) {
    return false;
  }
};

export const injectPWAMetaTags = async (website = PWA_CONFIG.COMPANY_WEBSITE) => {
  try {
    const manifestUrl = `${PWA_CONFIG.API_BASE_URL.replace(/\/$/, '')}/pwa/manifest.json?website=${website}`;    
    const response = await fetch(manifestUrl, { 
      signal: AbortSignal.timeout(5000)
    });      
    if (!response.ok) {
      return false;
    }
    const manifest = await response.json();
    if (manifest.icons && manifest.icons.length > 0) {
      manifest.icons = manifest.icons.map(icon => ({
        ...icon,
        src: icon.src.replace(/^http:\/\//i, 'https://')
      }));
    }
    const metaTags = [
      { name: 'apple-mobile-web-app-capable', content: 'yes' },
      { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
      { name: 'apple-mobile-web-app-title', content: manifest.short_name || manifest.name },
      { name: 'theme-color', content: manifest.theme_color || '#1976d2' },
      { name: 'mobile-web-app-capable', content: 'yes' },
    ];

    metaTags.forEach(tag => {
      let metaElement = document.querySelector(`meta[name="${tag.name}"]`);
      if (!metaElement) {
        metaElement = document.createElement('meta');
        metaElement.name = tag.name;
        document.head.appendChild(metaElement);
      }
      metaElement.content = tag.content;
    });

    if (manifest.icons && manifest.icons.length > 0) {
      const icon = manifest.icons.find(i => i.sizes === '192x192') || manifest.icons[0];
      let appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
      if (!appleIcon) {
        appleIcon = document.createElement('link');
        appleIcon.rel = 'apple-touch-icon';
        document.head.appendChild(appleIcon);
      }
      appleIcon.href = icon.src;
    }
    return true;
  } catch (error) {
    console.error('❌ Failed to inject PWA meta tags:', error);
    return false;
  }
};

export const isPWAInstalled = () => {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isIOSStandalone = window.navigator.standalone === true;
  return isStandalone || isIOSStandalone;
};

export const isPWAInstallable = (deferredPrompt) => {
  return deferredPrompt !== null && !isPWAInstalled();
};

export default {
  injectPWAManifest,
  injectPWAMetaTags,
  isPWAInstalled,
  isPWAInstallable,
};
